
export class Contact {
  id?: number;
  surname?: string;
  othername?: string;
  mobile: string;
  dob?: Date;
  custom_1?: string;
  custom_2?: string;
  custom_3?: string;
  custom_4?: string;
  group_id: number;
  group?: Group;
  checked?: boolean;

  constructor() {
    this.id = 0;
    this.surname = '';
    this.othername = '';
    this.mobile = '';
    this.dob = null;
    this.custom_1 = '';
    this.custom_2 = '';
    this.custom_3 = '';
    this.custom_4 = '';
    this.group_id = 0;
    this.group = new Group();
    this.checked = false;
  }
}

export class Group {
  id: number;
  name: string;
  custom_1?: string;
  custom_2?: string;
  custom_3?: string;
  custom_4?: string;
  contacts_count: number;

  constructor() {
    this.id = 0;
    this.name = '';
    this.custom_1 = '';
    this.custom_2 = '';
    this.custom_3 = '';
    this.custom_4 = '';
    this.contacts_count = 0;
  }
}

export class ContactGenerator {
  operator: string = '';
  group_id: number = 0;
  count: number = 0;
}

export class ContactGeneratorInfo {
  operators: string[] = [];
  cost: number = 0;
  max: number = 0;
}
